import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking/src/types.tsx';

const PACKAGE_NAME = 'jiraBusinessTimeline';

/**
 * This variable correspond to 'level' prop in the Timeline package
 * The level itself is based on jira internal knowledge where
 * 1 -> epic
 * 0 -> task
 * -1 -> subtask
 *
 * At this point in time, JBus timeline only wants to render a flat list
 * To do that we want to actually promote all our issues into epic level
 *
 * The main reason is because the roadmap component is
 * built in a way where top level is always equal to 1
 * And the child level is 0
 */

export const TIMELINE_PARENT_LEVEL = 1;
export const TIMELINE_CHILD_LEVEL = 0;
export const TIMELINE_EPIC_HIERARCHY_LEVEL = 1;
export const TIMELINE_SUBTASK_HIERARCHY_LEVEL = -1;
export const TIMELINE_ROOT_DEPTH = 0;

export const fieldIds = [
	'issuekey',
	'issuetype',
	'summary',
	'status',
	'assignee',
	'startdate',
	'duedate',
	'rank',
	'subtasks',
	'childIssues',
	'issuelinks',
	'parent',
];

export const DEPENDENCY_DRAG_ITEM_ID = 'dependency-drag-id';
export const DEPENDENCIES_DROP_TARGET_CLASS_NAME = 'dependencies-drop-target';

export const MAIN_EXPERIENCE: ExperienceDetails = {
	experience: 'timelineView',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};
export const LINK_ISSUES_EXPERIENCE: ExperienceDetails = {
	experience: 'linkIssues',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};
export const UNLINK_ISSUES_EXPERIENCE: ExperienceDetails = {
	experience: 'unlinkIssues',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};
export const LOAD_CHILD_ISSUES_EXPERIENCE: ExperienceDetails = {
	experience: 'loadChildIssues',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};
export const LOAD_MORE_EXPERIENCE: ExperienceDetails = {
	experience: 'loadMore',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};
export const SCHEDULE_ITEM_EXPERIENCE: ExperienceDetails = {
	experience: 'scheduleItem',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};

export const JIRA_SCHEDULE_ITEM_EXPERIENCE: ExperienceDetails = {
	experience: 'jiraScheduleItem',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};

export const RANK_ISSUE_EXPERIENCE: ExperienceDetails = {
	experience: 'rankIssue',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};
export const EXPORT_IMAGE_EXPERIENCE: ExperienceDetails = {
	experience: 'exportImage',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};
export const EXPORT_CSV_EXPERIENCE: ExperienceDetails = {
	experience: 'exportCsv',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};

export const UPDATE_PARENT_ISSUE_EXPERIENCE: ExperienceDetails = {
	experience: 'updateParentIssue',
	packageName: PACKAGE_NAME,
	teamName: 'jira-yurree',
};
